import { EditorOptionType, ToolbarOption } from '@/components/Editor/PlainEditor/types';
import {
  PRAISE_MESSAGE_EDITOR_DEFAULT_OPTIONS,
  PRAISE_MESSAGE_EDITOR_OPTION_MAP,
} from '@/modules/praises/views/PraiseWall/components/GivePraiseModal/components/PraiseMessage/consts';

import { EDITOR_AI_OPTION_MAP, TOOLBAR_ADD_AI_CONTENT, TOOLBAR_AI_DISCLAIMER } from '../../consts';

export const AI_PRAISE_MESSAGE_EDITOR_DEFAULT_OPTIONS = [
  TOOLBAR_ADD_AI_CONTENT,
  ToolbarOption.Separator,
  ...PRAISE_MESSAGE_EDITOR_DEFAULT_OPTIONS,
  ToolbarOption.Spacer,
  TOOLBAR_AI_DISCLAIMER,
];

export const AI_PRAISE_MESSAGE_EDITOR_OPTION_MAP = new Map<string, EditorOptionType>([
  ...PRAISE_MESSAGE_EDITOR_OPTION_MAP,
  ...EDITOR_AI_OPTION_MAP,
]);
